export default __webpack_public_path__ + "static/media/flag-tajikistan.aa53005f.svg";